import React from 'react'
import SvgWrapper from '../SvgWrapper'
import { DEFAULT_FILL_OPACITY, ICON_SIZE, ICON_VIEWBOX } from './constants'
import type { IconProps } from './types'

const NewsletterIcon: React.FC<IconProps> = ({
  viewBox = ICON_VIEWBOX.medium,
  color = 'currentColor',
  size = ICON_SIZE.medium,
  fillOpacity = DEFAULT_FILL_OPACITY,
}) => (
  <SvgWrapper aria-label="Newsletter Icon" viewBox={viewBox} size={size} fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.093 2A2.093 2.093 0 0 0 2 4.093v15.814C2 21.063 2.937 22 4.093 22h15.814A2.093 2.093 0 0 0 22 19.907V4.093A2.093 2.093 0 0 0 19.907 2H4.093zm-.698 2.093c0-.385.313-.698.698-.698h15.814c.385 0 .698.313.698.698v15.814a.698.698 0 0 1-.698.698H4.093a.698.698 0 0 1-.698-.698V4.093zm10.465 9.07a.698.698 0 0 0 0 1.395h4.652a.698.698 0 1 0 0-1.395H13.86zm-.697 3.488c0-.385.312-.697.697-.697h4.652a.698.698 0 1 1 0 1.395H13.86a.698.698 0 0 1-.697-.698zm.697 1.628a.698.698 0 1 0 0 1.395h2.791a.698.698 0 1 0 0-1.395h-2.79zm-9.07-4.418c0-.386.313-.698.698-.698h4.651a.698.698 0 0 1 0 1.395H5.49a.698.698 0 0 1-.698-.697zm.698 2.092a.698.698 0 1 0 0 1.396h4.651a.698.698 0 1 0 0-1.396H5.49zm-.697 3.024c0-.386.312-.698.697-.698H8.28a.698.698 0 1 1 0 1.395H5.49a.698.698 0 0 1-.698-.697zM5.953 4.79c-.642 0-1.162.52-1.162 1.162v4.652c0 .642.52 1.162 1.162 1.162h12.094c.642 0 1.162-.52 1.162-1.162V5.953c0-.642-.52-1.162-1.162-1.162H5.953zm.233 5.581V6.186h11.628v4.186H6.186z"
      fill={color}
      fillOpacity={fillOpacity}
    />
  </SvgWrapper>
)

export default NewsletterIcon
